import { backendClient } from "@/api/backendClient";

import type {
  MaintenanceDevice,
  MaintenanceDeviceReorder,
  MaintenanceDevicesInsert,
  MaintenanceDeviceUpdate,
} from "@waku-care/types/contracts/internal";

// local search / sort of the (unpaginated) device links of a maintenance
export const MAINTENANCE_DEVICE_LOCAL_SEARCHABLES = [
  "device.name",
  "device.manufacturer.name",
  "device.model.name",
  "checklist_template.title",
] as const;
export const MAINTENANCE_DEVICE_LOCAL_SORTABLES = ["device.name"] as const;

// ordered by ordering, created_at
export const getMaintenancesToDevices = async (maintenance_id: string) => {
  const { data, error } = await backendClient.get<MaintenanceDevice[]>(`/maintenances/${maintenance_id}/devices`);
  if (error) throw error;
  return data;
};

// ordering is appended on the backend, a started maintenance gets the devices' checklist template items right away
export const createMultipleMaintenanceToDevices = async ({
  id,
  values,
}: {
  id: string;
  values: MaintenanceDevicesInsert;
}) => {
  const { data, error } = await backendClient.post<MaintenanceDevice[]>(`/maintenances/${id}/devices`, {
    body: values,
  });
  if (error) throw error;
  return data;
};

// sets the checklist template of a device link
export const updateMaintenanceToDevice = async ({
  id,
  device_id,
  values,
}: {
  id: string;
  device_id: string;
  values: MaintenanceDeviceUpdate;
}) => {
  const { data, error } = await backendClient.patch<MaintenanceDevice>(`/maintenances/${id}/devices/${device_id}`, {
    body: values,
  });
  if (error) throw error;
  return data;
};

// removes the devices with their pending items
export const deleteMaintenanceToDevices = async ({ id, device_ids }: { id: string; device_ids: string[] }) => {
  const { error } = await backendClient.delete<null>(`/maintenances/${id}/devices`, { params: { device_ids } });
  if (error) throw error;
};

// moves a device onto the position of the drop target
export const reorderMaintenanceToDevice = async ({ id, values }: { id: string; values: MaintenanceDeviceReorder }) => {
  const { error } = await backendClient.put<null>(`/maintenances/${id}/devices/order`, { body: values });
  if (error) throw error;
};
